angular.module('CarsSaraBo').factory('ModificationPolicyService', ['$resource', function($resource) {
  return $resource('../rest/company/:companyOid/modificationPolicies/:oid', 
    { companyOid : '@companyOid'},
    {
    	save : {method:'POST'},
    	update : { method: 'PUT' },
    	remove : { method: 'DELETE' },
    	get: {method:'GET', isArray:true}
    }
  )}
]);


//////////////////
// WEBPACK FOOTER
// ./public/app/models/modification_policies_service.js
// module id = 855
// module chunks = 3